var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('span', {
    class: _vm.$style.DaysLeftOutput
  }, [_c(_setup.SIcon, {
    class: _vm.$style.icon,
    attrs: {
      "icon": "time",
      "size": _vm.iconSize
    }
  }), _vm._v("\n  " + _vm._s(_setup.daysLeft) + "\n  "), _c(_setup.DaysToDateOutput, {
    class: _vm.$style.days,
    attrs: {
      "input": _vm.input
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };